import { render } from "./vote.vue?vue&type=template&id=9ef1575a&scoped=true"
import script from "./vote.vue?vue&type=script&lang=js"
export * from "./vote.vue?vue&type=script&lang=js"

import "./vote.vue?vue&type=style&index=0&id=9ef1575a&scoped=true&lang=css"

import exportComponent from "/home/isa/qrcode-activity/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef1575a"]])

export default __exports__